<template>
  <div v-if="allowed" class="customer-hub-preference">
    <v-divider></v-divider>
    <v-list-item>
      <v-list-item-content>
        <v-switch
          :key="switchVersion"
          class="mt-1 pt-0"
          label="Neue Ansicht verwenden"
          :input-value="preferences.useNewView"
          :loading="preferences.saving"
          :disabled="preferences.saving || preferences.loading"
          color="primary"
          hide-details
          @change="saveViewPreference"></v-switch>
        <p class="customer-hub-preference__hint mb-1">
          Gilt für Home, Profil und Trainingshub auf deinem Konto. Du kannst jederzeit zur bisherigen Ansicht zurückwechseln.
        </p>
        <p v-if="preferences.error" class="customer-hub-preference__error mb-1" role="alert">{{ preferences.error }}</p>
      </v-list-item-content>
    </v-list-item>
  </div>
</template>

<script>
import customerHubPreferences from "@/services/customerHubPreferences"

export default {
  name: "CustomerHubPreferenceSwitch",
  data() {
    return { preferences: customerHubPreferences.state, switchVersion: 0 }
  },
  computed: {
    allowed() {
      return customerHubPreferences.isAllowed()
    },
  },
  methods: {
    async saveViewPreference(value) {
      if (!this.allowed || this.preferences.saving || this.preferences.loading) return
      try {
        await customerHubPreferences.savePreferences({ useNewView: Boolean(value) })
      } catch (_) {
        // The shared service retains the confirmed preference and exposes the error.
      } finally {
        // Vuetify keeps an internal switch value; restore the confirmed value on failure.
        this.switchVersion++
      }
    },
  },
}
</script>

<style scoped>
.customer-hub-preference__hint {
  max-width: 320px;
  color: rgba(255, 255, 255, 0.65);
  font-size: 12px;
  line-height: 1.5;
  white-space: normal;
}

.customer-hub-preference__error {
  max-width: 320px;
  color: #ffb4b4;
  font-size: 12px;
  line-height: 1.5;
  white-space: normal;
}
</style>
